import React from 'react';
import styled from '@emotion/styled';

const Content = styled.div`
  padding: 0 1.5rem;

  .error {
    color: var(--red);
  }
`;

const StatusBlock = (props) => {
  const { status, syncro, draftErrors } = props;

  return (
    <Content>
      <p>Статус: {status || 'Неизвестно'}</p>
      <p>Синхронизация: {syncro === true ? 'Синхронизирован' : 'Не синхронизирован'}</p>
      {draftErrors !== undefined && draftErrors.length !== 0 && (
        <>
          <p>Ошибка:</p>
          <span className="error">{draftErrors}</span>
        </>
      )}
    </Content>
  );
};

export default StatusBlock;
